import { ReactNode } from 'react'
import { TableContextType } from 'ui/components/CbTableV2'

export enum TableName {
  LeaderboardModalActiveUsers = 'LeaderboardModalActiveUsers',
  LeaderboardModalGameLeaderboard = 'LeaderboardModalGameLeaderboard',
  LeaderboardModalRewardsRedeemed = 'LeaderboardModalRewardsRedeemed',
  ManageActivities = 'ManageActivities',
  ManageCompanyRewards = 'ManageCompanyRewards',
  ManageFulfillments = 'ManageFulfillments',
  ManageGames = 'ManageGames',
  ManageGuideDetails = 'ManageGuideDetails',
  ManageGuides = 'ManageGuides',
  ManageMetrics = 'ManageMetrics',
  ManagePlayers = 'ManagePlayers',
  ManagePlayerTransactions = 'ManagePlayerTransactions',
  ManageRewards = 'ManageRewards',
  ManageTeams = 'ManageTeams',
  ManageTransactions = 'ManageTransactions',
  ManageTemplates = 'ManageTemplates',
  PayoutRecipients = 'PayoutRecipients',
  ROIPerformance = 'ROIPerformance',
  StatsModalActiveUsers = 'StatsModalActiveUsers',
  StatsModalRewardRedemptions = 'StatsModalRewardRedemptions',
  ThresholdPreview = 'ThresholdPreview',
}

type SelectionOption = {
  label: string
  value: string
}

type FilterConfigSingleSelection = {
  options: SelectionOption[]
  resetValue?: any
  type: FilterType.SingleSelection
}

type FilterConfigMultiSelection = {
  required?: boolean
  resetValue?: any
  options: SelectionOption[]
  type: FilterType.MultiWithBadges | FilterType.MultiCheckboxes
}

type FilterConfigDateRange = {
  resetValue?: any
  type: FilterType.DateRange
}

type FilterConfigUser = {
  resetValue?: any
  type: FilterType.UserSelection
}

export type FilterConfig =
  | FilterConfigSingleSelection
  | FilterConfigMultiSelection
  | FilterConfigDateRange
  | FilterConfigUser

export enum CellAlignment {
  Center = 'center',
  Left = 'left',
  Right = 'right',
}

export type Column = {
  cellAlignment: CellAlignment
  disableSort: boolean
  excludeDrawerFilter?: boolean
  filterable: boolean
  filterConfig?: FilterConfig
  id: string
  name: string
  primary: boolean
  queryParamId?: string
  quickFilterable: boolean
  quickFilterTooltipContent: string | null
  renderCell?: (row: any, context: TableContextType) => ReactNode
  renderTooltipContent?: () => ReactNode
  searchable: boolean
  searchLabel?: string
  searchParamId?: string
  value?: (row: any) => any
  valueFormatter?: (value: any) => string
  wrapText: boolean
}

export type TableConfig = {
  filters: Record<string, string | string[] | null>
  page: number
  perPage: number
  search?: {
    columnId?: string
    text?: string
  }
  sort?: {
    columnId?: string
    direction?: SortDirection
  }
  visibleColumns: string[]
}

export type ResultsWithMeta<ResultType> = {
  meta: {
    count: number
    page: number
    perPage: number
  }
  results: ResultType[]
}

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
  None = 'none',
}

export enum FilterType {
  DateRange = 'date',
  MultiWithBadges = 'multiWithBadges',
  MultiCheckboxes = 'multiCheckboxes',
  SingleSelection = 'single',
  UserSelection = 'user',
}

export type CacheKeyGenerator = (
  config: TableConfig,
  columnDefs: Column[],
) => string | any[]

export type ResultSetFromPromiseResolution<T> = (data: T) => unknown[]

export type ResultsPromiseFromCacheKey = (
  cacheKey: string | any[],
) => Promise<ResultsWithMeta<any>>
